import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getGroupName} from 'src/openapi/admin/apis/GetGroupNameApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    userSearchResultGroupsActions,
    userSearchResultGroupsDataSelector,
    userSearchResultGroupsResultSelector,
} from '../slices/user-search-result-groups.slice';
import {userSearchResultStateSelector} from '../slices/user-search-result-state.slice';

import type {UserSearchResultCacheKeys} from '../typedef';

type Props = {
    groupIds: number[],
    totalCount: number,
};

export const useGetUserSearchResultGroups = ({groupIds, totalCount}: Props) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback(() => apiDispatch(getGroupName({
        requestBody: groupIds,
    })), [groupIds, apiDispatch]);

    const setLoadedData = useCallback((
        response: Record<string, string>,
        dataCacheKeys: UserSearchResultCacheKeys,
    ) => {
        dispatch(userSearchResultGroupsActions.onSuccess(({
            cacheKeys: dataCacheKeys,
            totalCount,
            data: response,
        })));
    }, [totalCount, dispatch]);

    return useCachedTable({
        dataSelector: userSearchResultGroupsDataSelector,
        stateSelector: userSearchResultStateSelector,
        resultSelector: userSearchResultGroupsResultSelector,
        actions: userSearchResultGroupsActions,
        getAction,
        onSuccessLoad: setLoadedData,
        shouldClearOnUnmount: false,
    });
};
